import { motion } from "framer-motion";
import { ArrowUpRight, Wrench, CarFront, Radar, Truck, ShieldCheck } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToId } from "@/utils";

const ICONS = [Wrench, CarFront, Radar, Truck, ShieldCheck];

export const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="relative py-28 sm:py-36 bg-[#FAF9F6]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-20">
        <div className="lg:sticky lg:top-28 self-start">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#D4AF37]">{t.services.label}</span>
            </div>
            <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#111111]">
              {t.services.title}
            </h2>
          </motion.div>
        </div>

        <div>
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.button
                key={item.title}
                onClick={() => scrollToId("#quote")}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="group w-full text-left border-t border-black/10 py-9 sm:py-11 grid grid-cols-[auto_1fr_auto] items-start gap-5 sm:gap-8 hover:bg-black/[0.04] transition-colors duration-500 px-2 sm:px-4"
                data-testid={`service-chapter-${i + 1}`}
              >
                <span className="font-display font-bold text-4xl sm:text-5xl text-outline-white group-hover:text-[#D4AF37] group-hover:[-webkit-text-stroke:0px] transition-all duration-500 leading-none pt-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span>
                  <span className="flex items-center gap-3 mb-3">
                    <Icon className="w-5 h-5 text-[#D4AF37]" />
                    <span className="font-display font-semibold text-xl sm:text-2xl text-[#111111] tracking-tight">
                      {item.title}
                    </span>
                  </span>
                  <span className="block text-sm sm:text-base text-black/60 leading-relaxed max-w-xl">{item.desc}</span>
                </span>
                <ArrowUpRight className="w-6 h-6 mt-2 text-black/30 group-hover:text-[#D4AF37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500" />
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
